import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    resetTickets: null,
    queryTickets: ['queryKey', 'queryParams'],
    setTickets: ['queryKey', 'data'],
    getTicket: ['ticketId'],
    setSelectedTicket: ['ticket'],
    getEligibleAddonProducts: ['ticketId'],
    setEligibleAddonProducts: ['data']
})

export const TicketTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    tickets: {},
    selectedTicket: null,
    eligibleAddonProducts: {}
})

/* ------------- Reducers ------------- */
export const ticketResetTickets = (state) => INITIAL_STATE

export const ticketQueryTickets = (state, { queryKey, queryParams }) => Object.assign({}, state, { [queryKey]: null });

export const ticketSetTickets = (state, { queryKey, data }) => Object.assign({}, state, { [queryKey]: data });

export const ticketSetSelectedTicket = (state, { ticket }) => Object.assign({}, state, { selectedTicket: ticket });

export const ticketSetEligibleAddonProducts = (state, { data }) => Object.assign({}, state, { eligibleAddonProducts: data });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.RESET_TICKETS]: ticketResetTickets,
    [Types.QUERY_TICKETS]: ticketQueryTickets,
    [Types.SET_TICKETS]: ticketSetTickets,
    [Types.SET_SELECTED_TICKET]: ticketSetSelectedTicket,
    [Types.SET_ELIGIBLE_ADDON_PRODUCTS]: ticketSetEligibleAddonProducts
})